class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById('mini-cart').innerHTML = this.getSectionInnerHTML(html, '.shopify-section');

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));

        // Initialize free samples scroll after content is loaded
        setTimeout(() => {
          if (typeof initFreeSamplesScroll === 'function') {
            initFreeSamplesScroll();
          }
        }, 100);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    this.open();

    // Initialize free samples scroll after content is loaded
    setTimeout(() => {
      if (typeof initFreeSamplesScroll === 'function') {
        initFreeSamplesScroll();
      }
    }, 100);
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

// Free Samples Scroll Navigation
let scrollInitialized = false;
let resizeHandler = null;

function initFreeSamplesScroll() {
  const wrapper = document.querySelector('.free-samples__wrapper');
  if (!wrapper) {
    scrollInitialized = false;
    return;
  }

  const list = wrapper.querySelector('.free-samples__list');
  const leftArrow = wrapper.querySelector('.free-samples__arrow--left');
  const rightArrow = wrapper.querySelector('.free-samples__arrow--right');

  if (!list || !leftArrow || !rightArrow) {
    scrollInitialized = false;
    return;
  }

  // Prevent duplicate initialization
  if (scrollInitialized && leftArrow.hasAttribute('data-initialized')) {
    return;
  }

  const updateArrowStates = () => {
    const scrollLeft = list.scrollLeft;
    const maxScroll = list.scrollWidth - list.clientWidth;

    leftArrow.disabled = scrollLeft <= 0;
    rightArrow.disabled = scrollLeft >= maxScroll - 1;
  };

  const scroll = (direction) => {
    const scrollAmount = list.clientWidth * 0.8;
    const newScrollLeft = direction === 'left' ? list.scrollLeft - scrollAmount : list.scrollLeft + scrollAmount;

    list.scrollTo({
      left: newScrollLeft,
      behavior: 'smooth',
    });
  };

  // Create click handlers
  const leftClickHandler = () => scroll('left');
  const rightClickHandler = () => scroll('right');

  // Remove old event listeners if they exist
  if (leftArrow.hasAttribute('data-initialized')) {
    leftArrow.removeEventListener('click', leftClickHandler);
    rightArrow.removeEventListener('click', rightClickHandler);
  }

  leftArrow.addEventListener('click', leftClickHandler);
  rightArrow.addEventListener('click', rightClickHandler);
  list.addEventListener('scroll', updateArrowStates);

  // Mark as initialized
  leftArrow.setAttribute('data-initialized', 'true');
  rightArrow.setAttribute('data-initialized', 'true');

  // Initial state
  setTimeout(updateArrowStates, 50);

  // Update on window resize (remove old handler first)
  if (resizeHandler) {
    window.removeEventListener('resize', resizeHandler);
  }
  resizeHandler = () => setTimeout(updateArrowStates, 50);
  window.addEventListener('resize', resizeHandler);

  scrollInitialized = true;
}

// Initialize on various events
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFreeSamplesScroll);
} else {
  initFreeSamplesScroll();
}

// Re-initialize when cart drawer is opened
document.addEventListener('cartdrawer:opened', () => {
  setTimeout(initFreeSamplesScroll, 150);
});

// Re-initialize when cart is updated
document.addEventListener('cart:updated', () => {
  setTimeout(initFreeSamplesScroll, 150);
});

// Use MutationObserver to detect when free-samples section is added to DOM
const freeSamplesObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length) {
      const wrapper = document.querySelector('.free-samples__wrapper');
      if (wrapper) {
        setTimeout(initFreeSamplesScroll, 100);
        break;
      }
    }
  }
});

// Observe the mini-cart container
const miniCartEl = document.getElementById('mini-cart');
if (miniCartEl) {
  freeSamplesObserver.observe(miniCartEl, {
    childList: true,
    subtree: true,
  });
}
